import { Link, useParams } from 'react-router-dom';
import { Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { SalesPageShell } from './components/SalesPageShell';
import { btnPrimary, toastSales } from './components/sales-ui';
import { linkByToken, recordLinkEvent, subjectById } from './sales-store';

export default function SalesTrackedLinkPage() {
  const { token } = useParams<{ token: string }>();
  const hit = token ? linkByToken(token) : undefined;
  const subject = hit ? subjectById(hit.outreach.subjectId) : undefined;

  if (!hit || !token) {
    return (
      <SalesPageShell title="Tracked link" description="Unknown or expired token." crumbs={[{ label: 'Outreach' }]} icon={Link2}>
        <p className="text-sm text-gray-500">This mock link is not in the store.</p>
      </SalesPageShell>
    );
  }

  return (
    <SalesPageShell
      title="Tracked link"
      description="Mock click-through. Records an open, then a click, against the outreach."
      crumbs={[{ label: 'Outreach', href: '/admin/sales/outreach' }, { label: token }]}
      icon={Link2}
    >
      <div className="rounded-xl border border-gray-200 bg-white p-5">
        <p className="text-sm text-gray-700">
          {subject?.displayName ?? 'Prospect'} · dest <span className="font-mono text-xs">{hit.dest}</span>
        </p>
        <p className="mt-1 text-xs text-gray-400">{hit.outreach.trackedLinks.find((l) => l.token === token)?.events.length ?? 0} events recorded</p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button
            className={btnPrimary}
            onClick={() => {
              try {
                recordLinkEvent(token, 'open');
                recordLinkEvent(token, 'click');
                toast.success('Open and click recorded');
              } catch (e) {
                toastSales(e);
              }
            }}
          >
            Simulate visit
          </button>
          <Link to={`/admin/sales/prospects/${hit.outreach.subjectId}`} className="text-sm text-blue-700 hover:underline">
            Open prospect
          </Link>
        </div>
      </div>
    </SalesPageShell>
  );
}
